var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widM txtC bgFullX marTX padTX padBX padLS padRS",
      staticStyle: { color: "#000", "background-size": "100% 100%" },
      style: _vm.cssProps
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntH5 fntL" }, [
      _c("b", { staticClass: "light" }, [_vm._v("여기서 끝이 아니다!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntH2 marTS" }, [
      _c("strong", [_vm._v("아티스트리가 마구마구 쏩니다!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTX" }, [
      _c("img", {
        staticClass: "icoS",
        attrs: {
          src: require("@/assets/images/relay-event/logo_02.png"),
          alt: "인스타그램 로고"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntH6 marTX" }, [
      _vm._v("\n    스킨 뉴트리션 미니 제품을 체험하신 후"),
      _c("br"),
      _vm._v("\n    인스타그램에 아래 해시태그와 후기를 남겨주세요."),
      _c("br"),
      _vm._v("\n    추첨을 통해 선물을 보내 드립니다.\n  ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntH5 fntL marTL" }, [
      _c("b", { staticClass: "disIb" }, [_vm._v("#A7070")]),
      _vm._v(" "),
      _c("b", { staticClass: "disIb" }, [_vm._v("#아티스트리")]),
      _vm._v(" "),
      _c("b", { staticClass: "disIb" }, [_vm._v("#스킨뉴트리션")]),
      _c("br", { staticClass: "pcOnly" }),
      _vm._v(" "),
      _c("b", { staticClass: "disIb" }, [_vm._v("#건강한안티에이징의시작")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntH6 marTL" }, [
      _vm._v("\n    A7070이 마무리되는 "),
      _c("b", [_vm._v("3월")]),
      _vm._v(","),
      _c("br"),
      _vm._v("\n    본인 "),
      _c("b", [_vm._v("인스타그램의 DM")]),
      _vm._v("을 확인해주세요!"),
      _c("br"),
      _vm._v("\n    (별도의 공지 없이 당첨자에 한해 DM 발송됩니다.)\n  ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e66f8ab2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e66f8ab2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/relayevent/component/footer_event.vue
// module id = null
// module chunks = 